import { UAParser } from 'ua-parser-js';

var ua = navigator.userAgent;
const parser = new UAParser(ua);
var mtp = navigator.maxTouchPoints;
var OS = parser.getOS().name;

var isIPad = (OS == "Mac OS" && (mtp > 1));
var isIOS = (OS == "iOS");
var isAndroid = (OS == "Android") || ((OS == "Linux") && (mtp > 1));
var isMacbook = (OS == "Mac OS" && (mtp <= 1));

document.addEventListener('DOMContentLoaded', function () {
    const downloadButton = document.querySelectorAll('#download-button');
    const downloadButtonIOS = document.querySelectorAll('#download-button-ios');
    const downloadButtonAndroid = document.querySelectorAll('#download-button-android');
    const downloadButtonMacbook = document.querySelectorAll('#download-button-macbook');
    const standaloneSection = document.getElementById("standalone-installer");
    if(isIOS || isIPad){
        downloadButtonIOS.forEach(button => {
            button.classList.toggle('visible');
        });
    }else if(isAndroid){
        downloadButtonAndroid.forEach(button => {
            button.classList.toggle('visible');
        });
    }else if(isMacbook){
        downloadButtonMacbook.forEach(button => {
            button.classList.toggle('visible');
        });
    }else{
        downloadButton.forEach(button => {
            button.classList.toggle('visible');
        });
    }

    if(isIOS || isIPad || isAndroid) {
        standaloneSection.classList.toggle('hidden');
    }
});